var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"unstyled-link",attrs:{"href":`mailto:${_vm.email}`}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text ?? _vm.email)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }